/*
* Dropdrown 
*/
/*
* Matt Rajout animation sur le contenu
*/
let $dropdownItems = document.querySelectorAll('.icons-dropdown__item');
$dropdownItems.forEach(item => {
  item.addEventListener('click', function () {
    console.log(this);

    if (this.classList.contains('active')) {
      this.classList.remove('active');
      jQuery(".icons-dropdown__drop-content").slideUp(500)
    } else {
      let $activeItem = document.querySelector('.icons-dropdown__item.active');

      if ($activeItem != null) {
        $activeItem.classList.remove('active');
        jQuery(".icons-dropdown__drop-content").slideUp(500)
      }

      this.classList.add('active');
      jQuery(".active .icons-dropdown__drop-content").slideDown(500)
    }
  });
});